import { ThemedFunctor } from '@doveit/lego';
import React, { FunctionComponent, useEffect } from 'react';
import { TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC } from '../constants';

declare global {
  interface Window {
    Trustpilot: any,
  }
}

export const SCRIPT_TAG_ID = 'trustpilot-microscore-review';

export interface TrustpilotMicroReviewCountProps {
  addCss?: ThemedFunctor,
}

/**
 * @deprecated Use `TrustpilotWidget` with type TRUSTBOX_MICRO_REVIEW_COUNT
 */
export const TrustpilotMicroReviewCount: FunctionComponent<TrustpilotMicroReviewCountProps> = ({
  addCss,
}) => {
  const ref = React.createRef<HTMLDivElement>();

  useEffect(() => {
    // load script tag once that automatically swaps our content with iframe
    if (window && !window.document.getElementById(SCRIPT_TAG_ID)) {
      const script = window.document.createElement('script');
      script.id = SCRIPT_TAG_ID;
      script.src = TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC;
      window.document.head.appendChild(script);
    } else if (window.Trustpilot && ref.current) {
      // if script has been loaded before: call their API manually to redraw box
      window.Trustpilot.loadFromElement(ref.current);
    }
  });

  return (
    <div
      css={addCss}
      ref={ref}
      className="trustpilot-widget"
      data-locale="it-IT"
      data-template-id="5419b6a8b0d04a076446a9ad"
      data-businessunit-id="5cacae5d7b08650001e13ded"
      data-style-height="48px"
      data-style-width="100%"
      data-theme="light"
    />
  );
};

export default TrustpilotMicroReviewCount;
